import { render, staticRenderFns } from "./TranslationOverview.vue?vue&type=template&id=2bba9560"
import script from "./TranslationOverview.vue?vue&type=script&lang=js"
export * from "./TranslationOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports